import { call, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import {
  REQUEST, fetchSuccess, fetchFailure,
} from '../../actions/discovery/tournamentControl';
import { fetchRequest as fetchTournament } from '../../actions/discovery/tournament';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

// Stop the whole fitting run / cancel one entry / cancel the champion's
// serving-training. All three are cooperative POSTs; after any of them we
// refetch the leaderboard so the board reflects the new state immediately.
function* operation(action) {
  try {
    const { goalId, op, presetId } = action?.payload || {};
    let url;
    if (op === 'cancel_entry') {
      url = `${config.API_URL}/goals/${goalId}/tournament/entries/${presetId}/cancel`;
    } else if (op === 'cancel_training') {
      url = `${config.API_URL}/goals/${goalId}/tournament/training/cancel`;
    } else {
      url = `${config.API_URL}/goals/${goalId}/tournament/cancel`;
    }
    const response = yield call(
      axios.post, url, {}, { headers: getLocalUser() },
    );
    yield put(fetchSuccess({ op, presetId, data: response?.data?.data }));
    yield put(fetchTournament({ goalId }));
  } catch (error) {
    yield put(Error(error));
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  // takeEvery (not takeLatest): cancelling entry A must not abort an
  // in-flight cancel of entry B.
  yield takeEvery(REQUEST, operation);
}
